module.exports = __webpack_public_path__ + "static/casfer-footer-brand-7a7100e07c30be65c2572ef922fbee29.svg";